import { BUSINESS_TYPE } from '../../constants';
import { BusinessType } from '../../types/common';

/**
 * URL Search Paramsから区分のクエリ（Language:）を探して返す
 * @param q: [string]
 * @returns [BusinessType | undefined]
 */
const getBusinessTypeInSearchParams = (q: string): BusinessType | undefined => {
  const queryItems: string[] = q.split(' AND ');
  const languageQuery: string | undefined = queryItems.find((query) => query.indexOf('Language:') > -1);
  const queryValue: string | undefined = languageQuery ? languageQuery.split('Language:')[1] : undefined;
  if (queryValue === 'JP') {
    return BUSINESS_TYPE.DOMESTIC;
  } else if (queryValue === 'EN') {
    return BUSINESS_TYPE.EXPORT;
  } else {
    return undefined;
  }
};

export default getBusinessTypeInSearchParams;
